// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"styles_tableWrapper__1p2xN","col":"styles_col__3hW-2","fulfillmentStatus":"styles_fulfillmentStatus__3D1E8","emailCol":"styles_emailCol__1eVZP"};